<template>
  <div>
    <q-toolbar class="q-pr-none q-mb-md justify-end">
      <q-btn
        outline
        icon="mdi-filter-outline"
        color="primary"
        no-caps
        class="q-px-sm q-mx-sm"
        :label="$t('filter')"
        @click="filter = !filter"
      >
        <q-tooltip>{{ $t('filter') }}</q-tooltip>
      </q-btn>
      <q-btn
        outline
        color="primary"
        icon-right="archive"
        class="q-mr-sm"
        no-caps
        unelevated
        @click="exportCreativeLogs"
      >
        <q-tooltip>{{ $t('export_csv') }}</q-tooltip>
      </q-btn>
    </q-toolbar>

    <q-card flat v-if="filter" bordered class="q-mb-sm">
      <q-toolbar>
        <q-btn flat round dense class="q-ml-auto" icon="mdi-close" @click="filter = false" />
      </q-toolbar>
      <q-card-section class="q-pt-none row q-col-gutter-md">
        <div class="col-4">
          <select-request
            ref="segmentation"
            :label="$t('segmentation')"
            :v-model="params.segmentation"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/campaign/segmentation"
            option-label="description"
            option-value="id"
            clearable
            @update="(value) => (params.segmentation = value === null ? null : value.id)"
          />
        </div>
        <div class="col-4">
          <select-request
            ref="user"
            :v-model="params.user_id"
            :endpoint="'/user/admins'"
            :label="$t('user')"
            outlined
            clearable
            option-label="name"
            option-value="user_id"
            @update="(val) => (params.user_id = val === null ? null : val.user_id)"
          />
        </div>
        <div class="col-4">
          <date-input
            buttons
            ref="dateInput"
            outlined
            :label="$t('period')"
            :v-model="params.date"
            @update="(value) => (params.date = value)"
            clearable
            today-btn
            range
          />
        </div>
        <div class="col-12 text-right">
          <q-btn color="primary" :label="$t('clear')" no-caps outline class="q-px-md q-mx-md" @click="clearFilter" />
          <q-btn color="positive" :label="$t('search')" no-caps unelevated class="q-px-md" @click="onFilterLogs" />
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import CreativeLogMixin from '../../mixins/CreativeLogMixin';
import SelectRequest from '@/widgets/inputsGlobal/SelectRequest.vue';
import DateInput from '@/widgets/inputsGlobal/DateInput.vue';

export default {
  name: 'HeaderCreativeLog',
  components: { SelectRequest, DateInput },
  mixins: [CreativeLogMixin],
  data() {
    return {
      filter: true,
      params: {
        segmentation: null,
        user_id: null,
        date: ''
      }
    };
  },
  methods: {
    async exportCreativeLogs() {
      const data = await this.getAllCreativeLogs();
      if (!data.length) {
        this.errorNotify(this.$t('no_results_found'));
        return;
      }
      this.exportTableCsv(data, this.creativeLogColumns, 'creative_logs');
    },

    clearFilter() {
      this.params = {
        segmentation: null,
        user_id: null,
        date: ''
      };
      if (this.$refs.dateInput) this.$refs.dateInput.value = null;
      if (this.$refs.segmentation) this.$refs.segmentation.value = null;
      if (this.$refs.user) this.$refs.user.value = null;
      this.ActionSetFilterCreativeLog(null);
      this.getCreativeLogs();
    },

    onFilterLogs() {
      const filterSelect = [];

      if (this.params.segmentation) filterSelect.push(`segmentation=${this.params.segmentation}`);
      if (this.params.user_id) filterSelect.push(`user_id=${this.params.user_id}`);

      if (this.params.date) {
        if (this.params.date.split(' ').length === 3) {
          let [from, , to] = this.params.date.split(' ');
          from = this.$moment(this.stringToDate(from, 'dd/MM/yyyy', '/')).format('YYYY-MM-DD');
          to = this.$moment(this.stringToDate(to, 'dd/MM/yyyy', '/')).format('YYYY-MM-DD');
          filterSelect.push(`start_date=${from}`);
          filterSelect.push(`end_date=${to}`);
        } else {
          const date = this.$moment(this.stringToDate(this.params.date, 'dd/MM/yyyy', '/')).format('YYYY-MM-DD');
          filterSelect.push(`start_date=${date}`);
          filterSelect.push(`end_date=${date}`);
        }
      }

      this.ActionSetFilterCreativeLog(filterSelect.join('%26'));
      this.getCreativeLogs();
    }
  },

  created() {
    this.ActionSetFilterCreativeLog(null);
  }
};
</script>
